import {Link} from "react-router";
import {IUser} from "../models/auth";



export function breadcrumbItemRender(currentRoute: any, params: any, items: any, paths: any) {
    const isLast = currentRoute?.path === items[items.length - 1]?.path;

    return isLast ? (
        <span>{currentRoute.title}</span>
    ) : (
        <Link to={`/${paths.join("/")}`}>{currentRoute.title}</Link>
    );
}

export const getRole = (user: IUser) => {
        switch (user.role) {
            case 'admin':
                return 'Administrator'
            case 'owner':
                return 'Manager'
            default:
                return 'Invited'
        }
    }